import { DATAGRID_TABLE_CELL_WIDTH } from '../../../../utils/constants';

const parametriTablecColumns = (renderParameterDropdownCell, renderValueCell, renderActions) => [
  {
    field: 'parameter',
    headerName: 'Parameter',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    headerAlign: 'center',
    align: 'center',
    renderCell: renderParameterDropdownCell
  },
  {
    field: 'value',
    headerName: 'Values',
    width: 900,
    headerAlign: 'center',
    align: 'center',
    renderCell: renderValueCell,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    headerAlign: 'center',
    align: 'center',
    renderCell: renderActions,
  }
];

export { parametriTablecColumns };
